export default [
  {
    id: 'BKO',
    name: 'Backoffice',
    datePicker: 'date',
    dateMin: '2020-01-01',
    dateLabel: 'Fecha de cuadratura',
    fileHint: 'Debes cargar un archivo comprimido (.txt) con las tramas de los documentos que deseas emitir.'
  },
  {
    id: 'SAL',
    name: 'Libro de Ventas',
    datePicker: 'month',
    dateMin: '2020-01',
    dateLabel: 'Período',
    fileHint: 'Debes cargar el archivo .csv del Libro de Ventas descargado desde el Registro de Compras y Ventas del SII.'
  },
  {
    id: 'BOL',
    name: 'Libro de Boletas',
    datePicker: 'month',
    dateMin: '2020-01',
    dateLabel: 'Período',
    fileHint: 'Debes cargar el archivo .csv del Libro de Boletas descargado desde el Registro de Compras y Ventas del SII.'
  }
]
